import React from 'react';

import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {getDeviceNameByType} from '@/services/device/deviceData';
import {formatString} from '@/utils/stringUtils';
import {twx} from '@/utils/tailwindUtils';

import ConnectionProgress from '../../../components/ConnectionProgress';
import HowToUse from '../../../components/HowToUse';
import {getConnectionContent} from '../../connectionContentService';

const ConnectionPageContent = ({currentStep, steps, className, onOpenQsg, deviceType}) => {
    return (
        <div className={twx('flex flex-col items-center', className)}>
            <Icon />
            <Header currentStep={currentStep} deviceType={deviceType} />
            <Description currentStep={currentStep} deviceType={deviceType} />
            <ConnectionProgress steps={steps} currentStep={currentStep} className='mt-8' />
            <HowToUse className='mt-12 ml:mt-8' onOpenQsg={onOpenQsg} deviceType={deviceType} />
        </div>
    );
};

const Icon = ({className}) => {
    const {icon} = getConnectionContent();

    return <RemoteIconV2 icon={icon} className={twx('h-16 w-16 shrink-0', className)} />;
};

const Header = ({className, onClick, currentStep, deviceType}) => {
    const {connectionTitle, registrationTitle, synchronizeTitle} = getConnectionContent();
    const deviceName = getDeviceNameByType(deviceType);
    const title = currentStep === 0 ? connectionTitle : currentStep === 1 ? registrationTitle : synchronizeTitle;

    return (
        <h1 className={twx('mb-0 mt-4 text-28', className)} onClick={onClick}>
            {formatString(title, deviceName)}
        </h1>
    );
};

const Description = ({className, currentStep, deviceType}) => {
    const {connectionDescription, registrationDescription, synchronizeDescription} = getConnectionContent();
    const deviceName = getDeviceNameByType(deviceType);
    const description =
        currentStep === 0
            ? connectionDescription
            : currentStep === 1
              ? registrationDescription
              : synchronizeDescription;

    return <p className={twx('mt-4', className)}>{formatString(description, deviceName)}</p>;
};

ConnectionPageContent.Icon = Icon;
ConnectionPageContent.Header = Header;
ConnectionPageContent.Description = Description;
ConnectionPageContent.ConnectionProgress = ConnectionProgress;

export default ConnectionPageContent;
